import _ from 'lodash';
import { messageUtility } from './messageUtility';
import { STATUS_CODE } from './constants';

// apiレスポンスにエラーコードなどはないので文言から何のエラーか判定して
// 項目にエラー表示するかダイアログにするかの判定に用いる
export const isWorkDateError = message => {
  // 指定された作業日に稼働日が含まれていません。
  if (message.includes('指定された作業日に稼働日')) {
    return true;
  }
  return false;
};

/**
 * compare message equal prime contractor error message from API
 * @param  {string} message prime contractor error message
 * @return {boolean} true: equal、false: not equal
 */
export const isPrimeContractorHasBlockedOrFinishedWorkError = message =>
  message ===
  '元請担当者に設定したユーザーが作業終了または停止されています。 作業終了・停止しているユーザーは元請担当者に設定できないため、選択しなおしてください。';

export const isConcurrentErrorTracker = message =>
  message === messageUtility.getMessage('E-001-459');

/**
 * @description 協力会社作業が削除された確認
 * @param message 協力会社のデータを取得するエラーメッセージ
 * @param fieldTreeId 協力会社ID
 */
export const isDeletedFieldTreeError = (message, fieldTreeId) => {
  return _.includes(
    message,
    `現場ツリーID = [${fieldTreeId}] 対象のデータが存在しません`
  );
};

/**
 * Checks if the response indicates a duplicate transmission error.
 *
 * @param {Object} response - The response object from the API.
 * @param {number} response.status - The HTTP status code of the response.
 * @param {Object} response.data - The data object within the response.
 * @param {string} response.data.message - The message string within the data object.
 * @returns {boolean} - Returns true if the response status is 400 (bad request) and the message includes the specific error message for duplicate transmission.
 */
export const isDuplicateTransmissionError = response => {
  const status = _.get(response, 'status');
  const message = _.get(response, 'data.message');
  return (
    status === STATUS_CODE.badRequest &&
    _.includes(message, messageUtility.getMessage('E-000-052'))
  );
};

/**
 * Checks if the given message indicates that the operator is already registered.
 *
 * @param {string} message - The error message to check.
 * @returns {boolean} - Returns true if the message indicates the operator is already registered, otherwise false.
 */
export const isRegisterExistedOperator = message => {
  return _.includes(message, messageUtility.getMessage('E-001-453'));
};

/**
 * Checks if the given message indicates a copy latest error.
 *
 * @param {string} message - The error message to check.
 * @returns {boolean} - Returns true if the message indicates a copy latest error, otherwise false.
 */
export const isCopyLatestError = message =>
  message === messageUtility.getMessage('E-001-460');

export const isPermissionError = message =>
  message === messageUtility.getMessage('E-001-466');

export const isCcusJigyousyaNotConnectedError = message => {
  return message === 'CCUS事業者IDを設定してください。';
};

export const isKYTemporarySaveError = message =>
  message === messageUtility.getMessage('E-001-469');

export const hasRejectApprovalConflict = message =>
  message === messageUtility.getMessage('E-001-470');



// WEBPACK FOOTER //
// ./src/utilities/apiErrorMessage.js